export const LOAD_EBOOK = "LOAD_EBOOK";
export const RESET_EBOOK = "RESET_EBOOK";
export const LOAD_SELECTED_EBOOK = "LOAD_SELECTED_EBOOK";
export const LOAD_ALL_EBOOKS = "LOAD_ALL_EBOOKS";